<!--DEPUTY && OWNER-->
<template>
  <div class="position-relative">
    <Btn class="btn-secondary invite-member-class" @click="goToInviteMembers">
      {{ $t('_web_clan_invite-members', 'Invite members') }}
    </Btn>
    <ConversationButton />
    <span
      class="playhera-icon mx-4 cursor-pointer"
      @click.prevent="
        $event =>
          openSharingMenu({
            event: $event,
            type: clanAccount._type,
            text: `${$filters.displayName(clanAccount)} ${$t(
              '_web_' + clanAccount._type,
              clanAccount._type
            )} on `,
            id: clanAccount._id,
            vanityId: clanAccount.vanityId,
          })
      "
    >
      <AppIcon name="share" />
    </span>
    <button
      type="button"
      class="btn-transparent p-2 cursor-pointer text-secondary"
      @click="setActionPopover($event)"
    >
      <AppIcon name="settings-outline" />
    </button>
    <PopoverMenu
      v-if="statusBarMenuItems.length"
      :closest="$el"
      target-selector="svg"
      :position="actionPopoverPosition"
      :items="statusBarMenuItems"
      :float="['right', 'top']"
    >
      <template slot-scope="{ item }">
        <span
          v-if="item.action"
          :class="{ 'text-danger': item.isDanger }"
          @click="hideActionPopover(item.action)"
          >{{ item.text || item.textCall(clanAccount) }}</span
        >
        <router-link v-else-if="item.link" :to="item.link" class="reset-link">{{
          item.text
        }}</router-link>
      </template>
    </PopoverMenu>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { follow } from '@/mixins/accountActions/clan';
import PopoverMenu from '@/components/popover/Menu';
import AppIcon from '@/components/atoms/Icon';
import ConversationButton from '@/views/account/header/statusBar/default/ConversationButton';
import Btn from '@/components/atoms/HeraFormBtn.vue';

import { sharingMenu } from '@/mixins/sharingMenu';
import { CLAN_ROLES, PROFILE } from '@/constants/accounts';
export default {
  name: 'AccountStatusBarActionsEditClan',
  components: {
    ConversationButton,
    PopoverMenu,
    AppIcon,
    Btn,
  },
  mixins: [follow, sharingMenu],
  data() {
    return {
      actionPopoverPosition: null,
      isCaptain: false,
      myTeams: [],
    };
  },
  computed: {
    ...mapState('current', {
      clanAccount: 'account',
      clanId: 'accountId',
    }),
    ...mapState('my', ['account', 'accountId']),
    isOwner() {
      return this.clanAccount.role === CLAN_ROLES.OWNER;
    },
    statusBarMenuItems() {
      const items = [
        // {
        //   text: this.$t('_web_clan_invite-users', 'Invite users'),
        //   action: this.goToInviteMembers,
        // },
        {
          textCall: this.followClanText,
          action: this.followClanAction,
        },
        {
          text: this.$t('_web_clan_leave-team', 'Leave team'),
          action: this.clanLeaveAction,
        },
        {
          text: this.$t('_web_clan_edit-team', 'Edit team'),
          link: {
            name: this.$routerNames.EDIT,
            params: {
              ...this.clanAccount.params,
              ...this.$route.params,
            },
          },
        },
      ];

      if (this.isOwner) {
        items.push({
          text: this.$t('_web_team_delete-team', 'Delete team'),
          action: this.clanDeleteConfirm,
          isDanger: true,
        });
      }

      return items;
    },
    isLastMemberInClan() {
      return this.clanAccount.membersCount === 1;
    },
  },
  methods: {
    ...mapActions([
      'openModal',
      'deleteClan',
      'closeModal',
      'cancelUserFromMyClan',
      'errorNotify',
      'fetchClanCaptainsTeam',
    ]),
    ...mapActions('my', ['fetchMyAccount']),
    ...mapMutations('my/clans', { deleteMyClan: 'deleteClan' }),
    hideActionPopover(callback) {
      this.actionPopoverPosition = null;
      if (typeof callback === 'function') {
        callback(this.clanAccount);
      }
    },

    setActionPopover(event) {
      this.actionPopoverPosition = event.target
        .closest('button')
        .getBoundingClientRect();
    },
    goToInviteMembers() {
      this.$router.push({
        name: this.$routerNames.CLAN_MEMBERS,
        params: {
          ...this.clanAccount.params,
          ...this.$route.params,
        },
      });
    },
    goToMyAccount() {
      this.$router.push({
        name: this.$routerNames.ACCOUNT,
        params: { accountType: PROFILE, accountId: this.accountId },
      });
    },
    clanDeleteAction() {
      let clanID = this.clanId;
      this.deleteClan(clanID)
        .then(() => {
          this.deleteMyClan(clanID);
          this.goToMyAccount();
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.closeModal();
        });
    },
    clanDeleteConfirm() {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          title: this.$t('_web_team-delete_title', 'Delete team?'),
          text: this.$t(
            '_web_clan-delete_text',
            'Do you want to delete {name}? All teams and players will be dissolved',
            this.clanAccount
          ),
          confirmButtonText: this.$t(
            '_web_clan-delete_confirm-button',
            'Delete'
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: this.clanDeleteAction,
        },
        settings: {
          clickOnBackdrop: false,
          escKey: false,
        },
      });
    },
    getTeams() {
      this.fetchClanCaptainsTeam(this.clanId)
        .then(res => {
          this.isCaptain = !!res.length;
          this.myTeams = res;
        })
        .then(() => {
          this.clanLeaveConfirm();
        })
        .catch(this.errorNotify);
    },
    clanLeaveAction() {
      this.getTeams();
    },
    clanLeaveConfirm() {
      if (this.isOwner || this.isCaptain) {
        if (this.isLastMemberInClan) {
          this.openModal({
            name: 'HeraConfirm',
            props: {
              text: this.$t(
                '_web_clan-leave-text',
                'You cant leave clan in owner role. You have to delete your owner role to another clan member'
              ),
              confirmButtonText: this.$t('_web_clan-leave_confirm-ok', 'OK'),
            },
            events: {
              cancel: this.closeModal,
              confirm: () => {
                this.closeModal();
              },
            },
          });
        } else {
          this.openModal({
            name: 'ClanLeaveConfirm',
            props: {
              isOwner: this.isOwner,
              isCaptain: this.isCaptain,
              myTeams: this.myTeams,
            },
          });
        }
      } else {
        this.openModal({
          name: 'HeraConfirm',
          props: {
            text: this.$t(
              '_web_clan-leave_text',
              'Do you want to leave {name}?',
              this.clanAccount
            ),
            confirmButtonText: this.$t(
              '_web_clan-leave_confirm-button',
              'Leave'
            ),
          },
          events: {
            cancel: this.closeModal,
            confirm: () => {
              this.closeModal();
              this.removeFromClan();
            },
          },
        });
      }
    },
    removeFromClan() {
      this.cancelUserFromMyClan({
        clanID: this.clanId,
        login: this.accountId,
      })
        .then(this.fetchMyAccount)
        .then(this.goToMyAccount)
        .catch(this.errorNotify);
    },
  },
};
</script>
<style lang="scss" scoped>
.invite-member-class {
  background: var(--ph-secondary-text) !important;
}
</style>
